import { createRouter, createWebHistory } from 'vue-router';
import Partnership from '@/containers/Partnership/Parternship.vue';
const routes = [
  {
    path: '/',
    name: 'Partnership',
    component: Partnership,
    meta: {
      title: 'BCI2023 Partnership'
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  next();
});
export default router;
